import { IBaseItem, ILegacyCartEntry } from '@rbi-ctg/menu';

export const existsInEntries = (item: IBaseItem, entries: ILegacyCartEntry[]): boolean =>
  entries.some(
    (entry: ILegacyCartEntry) =>
      item._id === entry._id ||
      (entry.children.length ? existsInEntries(item, entry.children) : false)
  );
